import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';

@Injectable()
export abstract class PrivacyStateService {
  private ready$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  private privacyState$!: Observable<boolean>;

  constructor() {
    window.requestAnimationFrame(this.checkReady);
  }

  private checkReady = () => {
    const privacyState$ = (window as any).privacyState$;

    if (!privacyState$) {
      window.requestAnimationFrame(this.checkReady);
    } else {
      this.privacyState$ = privacyState$;
      this.ready$.next(true);

      console.log('PrivacyStateService ready');
    }
  };

  openCookieSettings() {
    const cookieSettingsButton = document.querySelector<HTMLButtonElement>(
      'button.ot-floating-button__open'
    );
    cookieSettingsButton?.click();
  }

  get canSubmitForm(): Observable<boolean> {
    return this.ready$.pipe(
      filter(Boolean),
      switchMap(() => {
        return this.privacyState$.pipe(
          map((x: any) => x['C0004'] || false),
          distinctUntilChanged()
        );
      })
    );
  }

  get canLoadMap(): Observable<boolean> {
    return this.ready$.pipe(
      filter(Boolean),
      switchMap(() => {
        return this.privacyState$.pipe(
          map((x: any) => x['C0003'] || false),
          distinctUntilChanged()
        );
      })
    );
  }
}
